import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <motion.div 
      className="flex flex-col items-center justify-center h-full py-16 px-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div 
        className="text-9xl font-bold text-primary-300 font-display"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ 
          scale: 1, 
          opacity: 1,
          transition: { 
            type: "spring",
            damping: 10,
            stiffness: 100 
          } 
        }}
      >
        404
      </motion.div>
      
      <motion.h1 
        className="mt-6 text-3xl font-bold text-gray-900 font-heading text-center"
        initial={{ y: 20, opacity: 0 }}
        animate={{ 
          y: 0, 
          opacity: 1,
          transition: { delay: 0.2 } 
        }}
      >
        Page Not Found
      </motion.h1>
      
      <motion.p 
        className="mt-4 text-center text-gray-600 max-w-md"
        initial={{ y: 20, opacity: 0 }}
        animate={{ 
          y: 0, 
          opacity: 1,
          transition: { delay: 0.3 } 
        }}
      >
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </motion.p>
      
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ 
          y: 0, 
          opacity: 1,
          transition: { delay: 0.4 } 
        }}
      >
        <Link to="/" className="mt-8 flex items-center text-primary-600 font-medium hover:text-primary-700 transition-colors">
          <ArrowLeft size={16} className="mr-2" />
          Back to Dashboard
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default NotFound; 